export default "__VITE_ASSET__ftIIIx6v__"